import { render, staticRenderFns } from "./ManageProductImport.vue?vue&type=template&id=5880e902&scoped=true"
import script from "./ManageProductImport.vue?vue&type=script&lang=js"
export * from "./ManageProductImport.vue?vue&type=script&lang=js"
import style0 from "./ManageProductImport.vue?vue&type=style&index=0&id=5880e902&prod&scoped=true&lang=css"
import style1 from "./ManageProductImport.vue?vue&type=style&index=1&id=5880e902&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5880e902",
  null
  
)

export default component.exports